// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ig-5";
export var filledCircle = "_ig-4";
export var historyEntry = "_ig-3";
export var messageSideLeft = "_ig-1";
export var messageSideRight = "_ig-2";
export var orderTrackingInfoContainer = "_ig-0";